import React, { useCallback } from 'react';
var Pill = function (_a) {
    var nursery = _a.nursery, clearNurserySearch = _a.clearNurserySearch, passWidth = _a.passWidth;
    var measureRef = useCallback(function (element) {
        if (element) {
            passWidth(Math.round(element.getBoundingClientRect().width));
        }
    }, [passWidth]);
    return (React.createElement("div", { ref: measureRef, className: "search__pill nursery" },
        React.createElement("span", null, "Nursery | "),
        nursery,
        React.createElement("span", { className: "x-btn", onClick: clearNurserySearch, role: "button", "aria-label": "x", tabIndex: 0, onKeyDown: clearNurserySearch })));
};
export default Pill;
